import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import db from "@/components/firebaseInit";
import DataListBio from "../../../components/Listing/DataListBio";
export default {
  components: {
    "data-list-bio": DataListBio
  },
  data: function data() {
    return {
      biography: [],
      isLoad: false,
      displayMode: "list"
    };
  },
  methods: {
    loadItems: function loadItems() {
      var _this = this;

      this.isLoad = false;
      db.collection("biography").get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var data = {
            id: doc.id,
            title: doc.data().title,
            date: doc.data().date,
            content: doc.data().content
          };

          _this.biography.push(data);

          _this.isLoad = true;
        });
      });
    }
  },
  computed: {},
  watch: {},
  mounted: function mounted() {
    this.loadItems();
  }
};